export const disconnectSvg = (
  <svg
    role="img"
    aria-label="ock-disconnect-svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Disconnect</title>
    <path
      d="M11.0668 0.91803L11.0668 2.93852L2.02049 2.93852L2.02049 15.0615L11.0668 15.0615L11.0668 17.082L-7.06549e-07 17.082L0 0.918029L11.0668 0.91803Z"
      className="fill-ock-foreground"
    />
    <path
      d="M12.3273 12.8963L16.0002 9.02606L12.346 4.95902L10.843 6.30941L12.3623 8.00032L5.53321 8.00032L5.53321 10.0208L12.2706 10.0208L10.8617 11.5054L12.3273 12.8963Z"
      className="fill-ock-foreground"
    />
  </svg>
);
